<template>
    <div class="modal fade" id="AddTypeDocumentModal" tabindex="-1" role="dialog" ref="addtypeDocumentRef" aria-labelledby="tooltipmodal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <Form ref="typeDocumentForm" @submit="addtypeDocument" :validation-schema="typeDocumentSchema">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Code <span class="text-danger">*</span>
                    </label>
                    <Field name="code" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                    <ErrorMessage name="code" class="text-danger"/>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Libellé
                    </label>
                    <Field name="libelle" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                    <ErrorMessage name="libelle" class="text-danger"/>
                  </div>
                </div>
                <button class="btn btn-primary" type="submit">
                  {{ btntext }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '@/services/ApiService';
  import * as Yup from 'yup';
  import { hideModal } from '@/utils/utils';
  import { ModeReglement } from '@/models/ModeReglement';
  import { error, success } from '@/utils/utils';
  import { useRouter } from 'vue-router';
import { Fonction } from '@/models/Fonction';
  
  export default defineComponent({
    name: "AddTypeDocumentModalPage",
    components: {
      Form,
      Field,
      ErrorMessage,
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }) {
      const typeDocumentSchema = Yup.object().shape({
        code: Yup.string().required('Le code est obligatoire'),
        libelle: Yup.string().nullable(), 
      });
  
      const typeDocumentForm = ref<any>(null); 
      const addtypeDocumentRef = ref<null | HTMLElement>(null);
      const router = useRouter();
      const isUPDATE = ref(false);
      const title = ref("Ajouter un typeDocument");
      const btntext = ref('Ajouter');
  
      
      const btnTitle = async () => {
        if (isUPDATE.value) {
          title.value = "Modifier un typeDocument";
          btntext.value = "Modifier";
        } else {
          title.value = "Ajouter un typeDocument";
          btntext.value = "Ajouter";
        }
      };
  
   
      const gettypeDocument = async (id: number) => {
        return ApiService.get("/typeDocument/" + id)
          .then(({ data }) => {
            const donnees = data.data;
            for (const key in donnees) {
              typeDocumentForm.value?.setFieldValue(key, donnees[key]);
            }
            emit('openmodal', addtypeDocumentRef.value);
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      };
  
 
      watch(() => props.item, (newValue) => {
        if (newValue) {
          gettypeDocument(newValue);
          isUPDATE.value = true;
          btnTitle();
        }
      });
  
   
      const addtypeDocument = async (values: any, { resetForm }) => {
        values = values as Fonction;
        if (isUPDATE.value) {
          ApiService.put("/typeDocument/" + values.id, values)
            .then(({ data }) => {
              if (data.code === 200) {
                success(data.message);
                resetForm();
                hideModal(addtypeDocumentRef.value);
                isUPDATE.value = false;
                btnTitle();
                emit('close');
              }
            })
            .catch(({ response }) => {
              error(response.data.message);
            });
        } else {
          ApiService.post("/typeDocument", values)
            .then(({ data }) => {
              if (data.code === 201) {
                success(data.message);
                resetForm();
                hideModal(addtypeDocumentRef.value);
                emit('close');
              }
            })
            .catch(({ response }) => {
              error(response.data.message);
            });
        }
      };
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value = false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle();
      };
  
      onMounted(() => {
       
      });
  
      return {
        typeDocumentSchema,
        addtypeDocumentRef,
        addtypeDocument,
        typeDocumentForm,
        title,
        btntext,
        resetValue,
      };
    },
  });
  </script>